import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const FileUploadWrapper = styled.div`
  .file-upload-container {
    margin: 16px 16px 8px 16px;

    ${responsive.MOBILE`
      margin: 16px;
    `}
  }

  .dropzone {
    border: 2px dashed ${COLORS.cirrus_black4};
    padding: 30px;
    width: 100%;
    text-align: center;
    height: 170px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: ${COLORS.cirrus_black1};
    box-sizing: border-box;

    ${responsive.MOBILE`
      padding: 16px;
      height: auto;
      min-height: 170px;
    `}
  }

  .dropzone-content {
    display: flex;
    flex-direction: column;
    color: ${COLORS.cirrus_black5};
    justify-content: center;
    align-items: center;
    word-break: break-word;
    text-align: center;

    b {
      color: ${COLORS.cirrus_black7};
    }

    ${responsive.MOBILE`
      gap: 4px;
      padding: 0 4px;
    `}
  }

  .label {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
  }

  .asterisk {
    color: ${COLORS.cirrus_red};
    margin-left: 5px;
  }

  .dropzone-content-title {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;

    ${responsive.MOBILE`
      gap: 4px;
      margin-bottom: 8px;
    `}
  }
  .upload-image-class {
    display: flex;
    justify-content: center;
    margin-bottom: 5px;

    ${responsive.MOBILE`
      margin-bottom: 4px;
    `}
  }
  .upload-image {
    width: 40px;
  }

  .dropzone-content {
    b {
      color: ${COLORS.cirrus_black7};
    }
  }
  .dropzone-label {
    color: ${COLORS.cirrus_black_dark};
  }
  .browse-button {
    height: auto;
    font-size: 16px;
    text-decoration: none;
    &:hover {
      text-decoration: none !important;
      background-color: transparent;
    }
    .browse-label {
      color: ${COLORS.primary_light_blue};
      text-decoration: underline;
      text-underline-offset: 4px;
    }
  }

  .error-container {
    margin: 0px 16px;
    display: flex;
    align-items: baseline;

    ${responsive.MOBILE`
      margin: 0 4px;
    `}
  }

  .error {
    color: ${COLORS.cirrus_red};
  }
`;
